// REACT
import React from "react";
import { useLocation } from "react-router-dom";

// MATERIAL-UI
import { Avatar, Button, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";

// COMPONENTS
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";

// ASSETS
import CloseIcon from "@mui/icons-material/Close";
import GA from "src/analytics/googleAnalytics";
import {
  CloseButton,
  Header,
  Wrapper,
} from "src/components/common/crypto-selection-modalV2/CryptoSelectionModalV2";
import Blank from "src/icons/Blank";
import { setDepositModal, useGlobalModalsSlice } from "src/store/features/modals.slice";
import { setSelectedCurrency } from "src/store/features/settings.slice";
import { useAppDispatch } from "src/store/store";
import { SelectCurrencyStyles } from "../common/styles/SelectCurrency.styles";
import { DropdownProps } from "../common/types/dropdownTypes";
import ModalTransition from "../Modal/ModalTransition";

/*
  ONLY USED FOR CURRENCY DROPDOWN IN WALLET PAGE AND TRANSACTION PAGE
*/

const Dropdown = (props: DropdownProps) => {
  const classes = SelectCurrencyStyles();
  const location = useLocation();

  // redux
  const reduxDispatch = useAppDispatch();

  const [open, setOpen] = React.useState<boolean>(false);

  // OPEN AND CLOSE MODAL
  const handleModalToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = (reason: any) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  // SEND SELECTED CURRENCY TO CONTEXT
  const handleCurrency = (event: React.MouseEvent, type: string): void => {
    event.stopPropagation();

    if (props.onClick) {
      const icon = event?.currentTarget.getAttribute("data-icon");
      props.onClick(icon, type);
      setOpen(false);
      return;
    }
    reduxDispatch(setSelectedCurrency(type));
    GA.currencySelection(type);
    setOpen(false);
    return;
  };

  const { depositModal } = useGlobalModalsSlice();
  const dispatch = useAppDispatch();

  // RUN USEEFFECT EVERYTIME THE DEPOSIT CRYPTO MENU BUTTON IS CLICKED
  React.useEffect(() => {
    if (location.pathname === "/wallets/deposit" && props.deposit && depositModal) {
      dispatch(setDepositModal(false));
      handleModalToggle();
    }
  }, [depositModal]);

  if (props.data.length <= 0) {
    return null;
  }

  return (
    <>
      <Button
        disableRipple
        id="wallet-currency-button"
        onClick={handleModalToggle}
        fullWidth={props.fullWidth ? props.fullWidth : false}
        variant="outlined"
        className={props.className ? props.className : classes.buttonContainer}
        size="large"
        endIcon={props.icon}>
        {props.children}
      </Button>

      <Wrapper
        open={open}
        TransitionComponent={ModalTransition}
        onClose={handleClose}
        aria-describedby="deposit-crypto-modal"
        PaperProps={{ className: classes.paperProps }}
        sx={{ "& .MuiDialog-paper": { height: "fit-content" } }}>
        <Header>
          Select Currency
          {/* close button */}
          <CloseButton onClick={handleClose}>
            <CloseIcon fontSize="inherit" />
          </CloseButton>
        </Header>

        {/* DROPDOWN CONTENT */}
        <Grid container>
          <Grid item xs>
            <List className={classes.list} id="currency-selection-list">
              {props.all ? (
                <>
                  {" "}
                  <Button disableRipple fullWidth key={"all"}>
                    <ListItem onClick={(event) => handleCurrency(event, "All")}>
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: "transparent" }}>
                          <Blank />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={<b>{"All"}</b>}
                        secondary={"All Currencies"}
                        sx={{ textTransform: "none" }}
                      />
                    </ListItem>
                  </Button>
                </>
              ) : null}
              {props.data.map((el: any, idx: any) => (
                <Button disableRipple fullWidth key={idx}>
                  <ListItem
                    data-code={el.code}
                    data-icon={el?.logoUrl}
                    data-name={el.name}
                    onClick={(event) => handleCurrency(event, el.code)}>
                    <ListItemAvatar>
                      <Avatar style={{ backgroundColor: "transparent" }}>
                        <CountryOrCryptoFlag name={el?.logoUrl || el.code} size={40} />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={<b>{el.code}</b>}
                      secondary={el.name}
                      sx={{ textTransform: "none" }}
                    />
                  </ListItem>
                </Button>
              ))}
            </List>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
};

export default Dropdown;
